"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Panel = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var Panel = function (props) {
    var className = props.className, id = props.id, children = props.children, panelBodyClassName = props.panelBodyClassName;
    return (react_1.default.createElement(Wrapper, { className: (0, classnames_1.default)('panel', className), id: id },
        react_1.default.createElement("div", { className: (0, classnames_1.default)('panel-content', panelBodyClassName) }, children)));
};
exports.Panel = Panel;
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 2px;\n  border: 1px solid #d7d7d7;\n  padding: 15px;\n\n  .panel-content {\n    position: relative;\n\n    @media (max-width: 767px) {\n      padding: 10px;\n    }\n  }\n"], ["\n  border-radius: 2px;\n  border: 1px solid #d7d7d7;\n  padding: 15px;\n\n  .panel-content {\n    position: relative;\n\n    @media (max-width: 767px) {\n      padding: 10px;\n    }\n  }\n"])));
exports.default = exports.Panel;
var templateObject_1;
